import { APIError } from 'models';

export type CreateRolloutRequest = {
  data: {
    attributes: {
      name: string;
      softwareId: string;
      pnc: string;
      excludeTestDevices: boolean;
    };
  };
};

export type Rollout = {
  id: string;
  type: string;
  attributes: {
    name: string;
    software: string;
    progress: RolloutProgress;
    createdAt: number;
    lastModifiedAt: number;
    totalTargets: number;
    status: string;
    pnc?: string;
    excludeTestDevices?: boolean;
    iprIds?: string[];
  };
};

export type RolloutProgress = {
  succeeded?: number;
  failed?: number;
  waiting?: number;
  notStarted?: number;
  cancelled?: number;
  scheduled?: number;
};

export type RolloutGroup = {
  name: string;
  status: string;
  totalTargets: number;
  progress: RolloutProgress;
  id: number;
};

export type RolloutList = {
  data: Rollout[] | null;
  totalCount: number;
  isLoading: boolean;
  error: APIError | null;
  filters: {
    active: boolean;
    data: RolloutFilter[] | null;
  };
};
export enum RolloutFilterAttribute {
  NAME = 'name',
  SOFTWARE_ID = 'softwareId',
}
export type RolloutFilter = {
  attribute: RolloutFilterAttribute;
  value: string;
};

export type RolloutState = {
  list: RolloutList;
  rolloutDetail: {
    data: Rollout | null;
    isLoading: boolean;
    error: APIError | null;
    groups: {
      data: RolloutGroup[] | null;
      totalCount: number;
      isLoading: boolean;
      error: APIError | null;
    };
    devices: {
      data: DeviceInRolloutAttributes[] | null;
      filters: {
        data: DeviceFilter[] | null;
        active: boolean;
      };
      totalCount: number;
      isLoading: boolean;
      error: APIError | null;
    };
  };
};

export enum DeviceFilterAttribute {
  DETAIL_STATUS = 'detailStatus',
  GROUP_ID = 'rolloutGroupId',
}

export type DeviceFilter = {
  attribute: DeviceFilterAttribute;
  value: string;
};

export type DevicesByStatus = {
  status: string;
  devices: DeviceInRollout[];
};

export type DeviceInRollout = {
  id: string;
  attributes: DeviceInRolloutAttributes;
};

export type DeviceInRolloutAttributes = {
  iprId: string;
  status: string;
  detailStatus: string;
  softwareUpdateType: string;
  lastModifiedAt: number;
};

export type GroupsInRollout = {
  id: string;
  attributes: GroupsInRolloutAttributes;
};

export type GroupsInRolloutAttributes = {
  groupId: number;
  name: string;
  progress: RolloutProgress;
  totalTargets: number;
  status: string;
};

export type RolloutsSuccess = {
  response: Rollout[];
  totalCount: number;
  filters: RolloutFilter[] | null;
};

export type DevicesInRolloutSuccess = {
  response: {
    filters: DeviceFilter[] | null;
    devices: DeviceInRollout[];
    totalCount: number;
  };
};

export type GroupsInRolloutSuccess = {
  response: {
    groups: GroupsInRollout[];
    totalCount: number;
  };
};

export type RolloutSuccess = {
  response: Rollout;
};

export interface RolloutsResponse {
  data: Rollout[];
  meta: RolloutMeta;
  errors?: APIError[];
}

export interface RolloutResponse {
  data: Rollout;
  errors?: APIError[];
}

export interface DevicesInRolloutResponse {
  data: DeviceInRollout[];
  meta: RolloutMeta;
  errors?: APIError[];
}

export interface GroupssInRolloutResponse {
  data: GroupsInRollout[];
  meta: RolloutMeta;
  errors?: APIError[];
}

export type RolloutMeta = {
  totalCount: number;
};

export enum CreateRolloutAttribute {
  Name = 'name',
  Software = 'software',
  Pnc = 'pnc',
  IprIds = 'iprIds',
  ExcludeTestDevices = 'excludeTestDevices',
}
